'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

(function ($, RIKEN) {
	var a = 'is-active';
	var v = 'is-visible';
	var slideSpeed = '400';
	var arrowPrev = '<button type="button" class="slick-prev"><svg class="icon" data-view="pc"><use xlink:href="/common/svg/sprite.svg#arrow_left" /></svg><img src="/common/images/arrow_left_waku.svg" class="icon" data-view="tablet sp" /></button>';
	var arrowNext = '<button type="button" class="slick-next"><svg class="icon" data-view="pc"><use xlink:href="/common/svg/sprite.svg#arrow_right" /></svg><img src="/common/images/arrow_right_waku.svg" class="icon" data-view="tablet sp" /></button>';
	var $path = location.pathname;

	// ==============================================================
	// JSON取得 ======================================================
	// 商品・シリーズ情報取得
	var getAllJSON = function getAllJSON() {
		Promise.all([$.getJSON('/ajax/recipe_products/available.json'), $.getJSON('/ajax/recipe_all/list.json'), $.getJSON('/ajax/recipe_tags/all.json')]).then(function (_ref) {
			var _ref2 = _slicedToArray(_ref, 3),
			    productsData = _ref2[0],
			    recipesData = _ref2[1],
			    tagsData = _ref2[2];

			var products = (productsData.rt_bn_recipe_products_all_list || []).sort(function (a, b) {
				return a.cf_p_order - b.cf_p_order;
			});
			var series = products.map(function (item) {
				return item.cf_p_category;
			}).sort(function (a, b) {
				return a.cf_pc_series_order - b.cf_pc_series_order;
			}).filter(function (obj, index, self) {
				return index === self.findIndex(function (t) {
					return t.cf_pc_series_code === obj.cf_pc_series_code;
				});
			});

			var productKeys = products.map(function (item) {
				return item._key;
			});

			var recipes = (recipesData.rt_bn_recipe_all_list || []).filter(function (recipe) {
				return recipe.cf_r_products_main !== null;
			}).filter(function (recipe) {
				var mainProduct = recipe.cf_r_products_main._key;
				var subProductList = recipe.cf_r_products_sub.map(function (product) {
					return product._key;
				});
				var productList = [mainProduct].concat(_toConsumableArray(subProductList));

				var allIncluded = productList.every(function (item) {
					return productKeys.includes(item);
				});
				return allIncluded;
			});

			var activeProductKeys = Array.from(new Set(recipes.map(function (recipe) {
				var recipeProducts = [recipe.cf_r_products_main._key].concat(_toConsumableArray(recipe.cf_r_products_sub.map(function (product) {
					return product._key;
				}))).filter(function (item) {
					return item && item !== null;
				});
				return recipeProducts;
			}))).flat();

			products = products.filter(function (item) {
				return activeProductKeys.includes(item._key);
			});

			var activeSeriesKeys = Array.from(new Set(products.map(function (product) {
				return product.cf_p_category.cf_pc_series_code;
			}))).flat();

			series = series.filter(function (item) {
				return activeSeriesKeys.includes(item.cf_pc_series_code);
			});

			var tags = tagsData.rt_bn_recipe_tags_all_list || [];

			window.RIKEN.jsonData = {
				init: true,
				recipes: recipes,
				products: products,
				series: series,
				tags: tags
			};

			return { recipes: recipes, products: products, series: series, tags: tags };
		});
	};

	// ＜ルート設定対応＞要素が空だったら削除
	var removeElmIfEmpty = function removeElmIfEmpty() {
		$('.js-checkEmptyElm').each(function (idx, val) {
			if (!$(val).text().length) {
				$(val).remove();
			}
		});
	};
	// ＜ルート設定対応＞該当のリストにルート設定出力が0件の場合、指定する親ブロックごと削除する
	var removeBlockIfListEmpty = function removeBlockIfListEmpty() {
		if ($('.js-checkEmptyList').length) {
			$('.js-checkEmptyList').each(function (idx, val) {
				if (!$(val).find('li').length) {
					$(val).parents('.js-checkEmptyList-wrap').remove();
				}
			});
		}
	};

	// <共通>lazyLoad
	var imglazyLoad = function imglazyLoad() {
		document.addEventListener("DOMContentLoaded", function () {
			var lazyImages = [].slice.call(document.querySelectorAll("img.lazy"));

			if ("IntersectionObserver" in window) {
				var lazyImageObserver = new IntersectionObserver(function (entries, observer) {
					entries.forEach(function (entry) {
						if (entry.isIntersecting) {
							var lazyImage = entry.target;
							lazyImage.src = lazyImage.dataset.src;
							if (typeof lazyImage.dataset.srcset === "undefined") {} else {
								lazyImage.srcset = lazyImage.dataset.srcset;
							}
							lazyImage.classList.remove("lazy");
							if (lazyImage.classList.contains("lazy-img")) {
								lazyImage.addEventListener("load", function () {
									var wrapElm = getClosest(lazyImage, "figure.lazy-imgWrap");
									wrapElm.classList.add("is-loaded");
								});
							}
							lazyImageObserver.unobserve(lazyImage);
						}
					});
				}, { rootMargin: "50px" });

				lazyImages.forEach(function (lazyImage) {
					lazyImageObserver.observe(lazyImage);
				});
			} else {
				// Possibly fall back to a more compatible method here
			}
			function getClosest(node, selector) {
				return (node.closest || function (_selector) {
					do {
						if ((node.matches || node.msMatchesSelector).call(node, _selector)) {
							return node;
						}
						node = node.parentElement || node.parentNode;
					} while (node !== null && node.nodeType === 1);

					return null;
				}).call(node, selector);
			}
		});
	};

	// 汎用スライダー
	var modSlider01 = function modSlider01() {
		if ($('.js-modSlider01').length) {
			$('.js-modSlider01').slick({
				infinite: true,
				speed: 1000,
				autoplaySpeed: 4000,
				autoplay: true,
				slidesToShow: 4,
				arrows: true,
				dots: true,
				prevArrow: arrowPrev,
				nextArrow: arrowNext,
				responsive: [{
					breakpoint: 1024,
					settings: {
						slidesToShow: 2,
						arrows: false,
						speed: 500
					}
				}, {
					breakpoint: 768,
					settings: {
						slidesToShow: 1,
						arrows: false,
						speed: 500
					}
				}]
			});
		}
	};

	// ニュースファイルサイズ変換
	var newsFileSize = function newsFileSize() {
		$('.js-fileSize').each(function (idx, ele) {
			$(ele).text('（' + bytesToSize($(ele).text()) + '）');
			$(ele).addClass(a);
		});
		function bytesToSize(bytes) {
			var sizes = ['Bytes', 'KB', 'MB', 'GB'];
			if (bytes === 0) return '0 Byte';
			var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
			var convSize = Math.floor(bytes / Math.pow(1024, i) * Math.pow(10, 1)) / Math.pow(10, 1);
			// KBのとき、小数点切り捨て
			//if(i === 1) convSize = Math.round(convSize);
			return convSize + sizes[i];
		}
	};

	// 動的に書き出す®をsubで囲う
	var addSub = function addSub(_txt) {
		if (_txt.indexOf('®') !== -1 || _txt.indexOf('🄬') !== -1) {
			var newTxt = _txt.replace(/®|🄬/g, '<sub>&reg;</sub>');
			return newTxt;
		} else {
			return _txt;
		}
	};

	// 「おすすめ旬レシピ」 =====================================
	// JSON取得
	var getJSONrecipeData = function getJSONrecipeData(_key) {
		return $.getJSON('/ajax/recipe/' + _key + '.json');
	};
	var getJSONproductsData = function getJSONproductsData(_key) {
		return $.getJSON('/ajax/products/' + _key + '.json');
	};
	// スライド
	var recipeSlider = function recipeSlider() {
		$('.js-recipe-slider').slick({
			infinite: true,
			speed: 800,
			autoplay: false,
			pauseOnHover: false,
			slidesToShow: 1,
			fade: true,
			arrows: true,
			dots: true,
			prevArrow: arrowPrev,
			nextArrow: arrowNext,
			appendDots: $('.top-recipe-slideWrap'),
			appendArrows: $('.top-recipe-inner'),
			customPaging: function customPaging(slider, index) {
				$('.top-recipe-slide-item').eq(index).find('.__num').text('0' + Number(index + 1));
				return $('<button type="button" />').text('0' + Number(index + 1));
			},
			responsive: [{
				breakpoint: 1025,
				settings: {
					speed: 500
				}
			}]
		});
	};

	var recommendRecipe = function recommendRecipe() {

		RIKEN.checkJsonDataInit().then(function () {
			if ($('.js-recommend-recipe').length) {

				// 表示／非表示
				$('.js-pickup-item').each(function (idx, ele) {
					var thisStatus = $(ele).find('.rt_cf_r_status').text();
					if (thisStatus === '0') {
						$(ele).remove();
					}
				});

				// 使用している商品
				$('.js-recommend-recipe').each(function (idx, ele) {
					var recipeId = $(ele).find('.rt_recipe_key').text();

					var recipe = RIKEN.jsonData.recipes.find(function (recipe) {
						return recipe._key === recipeId;
					});
					if (!recipe) {
						if ($path === '/recipe/' || $path === '/recipe/index.html') {
							$(ele).parents('.js-pickup-item').remove();
						} else {
							$('.js-recipe-slider.slick-initialized').slick('unslick');
							$(ele).parents('.top-recipe-slide-item').remove();
							recipeSlider();
						}
						return;
					}

					var productsData = RIKEN.jsonData.products.find(function (product) {
						return product._key === recipe.cf_r_products_main._key;
					});
					var _name = productsData.cf_p_name;
					var _img = productsData.cf_p_img;
					var _hasDetailFlg = productsData.cf_p_detail_page_flag;
					var _category = productsData.cf_p_category.cf_pc_code;
					var _series = productsData.cf_p_category.cf_pc_series_code;
					var _id = productsData._key;
					var _url = "";
					var _class = '';
					var productsHtml = '';

					if (_hasDetailFlg === 0) {
						_url = '/products/' + _category + '/' + _series + '/' + _id + '.html';
					} else {
						_class = 'is-disable';
					}

					// 商品が公開設定の場合
					if ($(ele).hasClass('recipe-item')) {
						productsHtml = '<div class="__txtWrap">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="__head">\u4F7F\u7528\u3057\u3066\u3044\u308B\u5546\u54C1\uFF1A</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<a href="' + _url + '" class="__txt ' + _class + '">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class="">' + _name + '</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t<a href="' + _url + '" class="__img ' + _class + '">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<img src="/products/products_file/file/' + _img + '" alt="' + _name + '" class="">\n\t\t\t\t\t\t\t\t\t\t\t\t</a>';
					} else {
						productsHtml = '<a href="' + _url + '" class="mod-a opacity ' + _class + '"><figure class="__img">\n\t\t\t\t\t\t\t\t\t\t\t\t<img src="/products/products_file/file/' + _img + '" alt="' + _name + '" class="">\n\t\t\t\t\t\t\t\t\t\t\t</figure>\n\t\t\t\t\t\t\t\t\t\t\t<div class="__txtWrap">\n\t\t\t\t\t\t\t\t\t\t\t\t<p class="__head">\u4F7F\u7528\u3057\u3066\u3044\u308B\u5546\u54C1</p>\n\t\t\t\t\t\t\t\t\t\t\t\t<p class="__name">' + addSub(_name) + '</p>\n\t\t\t\t\t\t\t\t\t\t\t</div></a>';
					}

					$(ele).find('.js-products-output').append(productsHtml);

					if (idx === $('.js-recommend-recipe').length - 1) {
						if ($path === '/recipe/' || $path === '/recipe/index.html') {
							$('.js-pickup-item:nth-child(n + 7)').remove();
							// <レシピTOP> 7個目以降削除
						} else {
							//　<総合TOP><商品情報TOP> 4個目以降を削除
							$('.js-recipe-slider.slick-initialized').slick('unslick');
							$('.top-recipe-slide-item:nth-child(n + 4)').remove();
							recipeSlider();
						}
					}
				});
			}
		});

		recipeSlider();
	};

	removeElmIfEmpty();
	removeBlockIfListEmpty();
	imglazyLoad();
	modSlider01();
	getAllJSON();
	recommendRecipe();
	if ($('.js-fileSize').length) {
		newsFileSize();
	}
})(window.jQuery, window.RIKEN);